<template>
  <div class="index">
    <el-carousel style="height: 500px">
      <el-carousel-item
        v-for="item in list"
        :key="item.id"
        style="cursor: pointer; height: 500px"
      >
        <img
          class="el-carousel__img"
          style="width: 100%"
          :src="item.imgUrl"
          alt=""
          @click="jump(item)"
        />
      </el-carousel-item>
    </el-carousel>
  </div>
</template>

<script>
import { getHomeBannerList } from "@/api/index";
export default {
  name: "Index",
  data() {
    return {
      list: [],
    };
  },
  created() {
    sessionStorage.setItem("tabId", 0);
    this.getHomeBannerList();
  },
  methods: {
    jump(item) {
      if (item.targetUrl) {
        window.open(item.targetUrl);
      }
    },
    getHomeBannerList() {
      getHomeBannerList().then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>

<style scoped>
.index {
  background: #171f30;
}

.el-carousel__img {
  height: 500px;
  object-fit: cover;
}
</style>
